import type { IRecordTypeDefinition } from '@platform/core/types';
import { isKb } from './formRules';
import type { IProtoForm } from './IProtoForm';
import { standardGroupsOf } from './standardGroups';
import { workspaceFieldsOf } from './workspaceFields';

/**
 * Стандартний макет форми прототипу v4 (без layout): статус, пріоритет і термін — у ключовому рядку, теги й опис — під заголовком,
 * вкладки «Доручення», «Коментарі», «Файли» увімкнені, «Пов’язані елементи» й «Історія» — як у типовій формі типу (`baseTabs`, mm.tabs
 * прототипу), стандартні групи з полів у порядку простору, без прихованих полів і явних ширин. Чиста функція.
 */
export function standardFormOf(rt: IRecordTypeDefinition, baseTabs: readonly string[]): IProtoForm {
  return {
    key: { status: true, priority: true, due: true },
    showTags: true,
    showDesc: true,
    tabs: { assignments: true, related: baseTabs.includes('related'), comments: true, files: true, history: baseTabs.includes('history') },
    groups: standardGroupsOf(workspaceFieldsOf(rt), { status: true, tags: true, description: !isKb(rt) }),
    hidden: [],
    widths: {},
  };
}
